import { createApiClient } from '@aspid/api-client';

import { queries } from '@api';
import { queryClient } from '@api/api.queryClient.ts';
import { ApiUrls } from '@api/api.urls';

import { HttpClient } from './HttpClient';

export { UNKNOWN_SERVER_ERROR_MESSAGE } from '@aspid/api-client';

/**
 * Обвязка приложения поверх общего клиента.
 *
 * Транспорт, разбор ошибок и защита от рекурсии на 401 живут в
 * `@aspid/api-client`; здесь остаётся только то, что знает приложение: свой
 * `HttpClient`, свои ключи запросов и свой URL разлогинивания.
 *
 * Что приложение получает при переезде (AF-13):
 * - разбор трёх форматов тела ошибки. Раньше в `message` подставлялся
 *   `data.detail` без проверки, и ответ без `detail` — например, чистые
 *   field-errors DRF — показывал пользователю строку `undefined`;
 * - `fields` с field-level ошибками для подсветки полей формы;
 * - сериализацию массивов в query повторяющимися ключами,
 *   которую понимает DRF;
 * - защиту от рекурсии, когда сам `/auth/force-logout` отвечает 401.
 *
 * Путь модуля не менялся намеренно — импорты в остальном приложении
 * (`@api/apiUtils/makeAxiosRequest`) продолжают работать.
 */
const apiClient = createApiClient({
  httpClient: HttpClient,
  onUnauthorized: () => handleUnauthorizedError(),
});

export const { makeAxiosRequest } = apiClient;

export const forceLogOutUser = () =>
  makeAxiosRequest<undefined>({
    url: ApiUrls.auth.forceLogout,
    method: 'post',
  });

export const handleUnauthorizedError = async () => {
  await forceLogOutUser();
  await queryClient.invalidateQueries({
    queryKey: queries.users.activeUser.queryKey,
    refetchType: 'all',
  });
  // Обновление страницы
  globalThis.location.reload();
};
